<template>
  <div class="product-detail">
    
    <div class="space"></div>
    <br />
    <p class="align-left bcrumb">Shop &nbsp; / &nbsp; {{ title }}</p>
    <br />
    <b-row class="m-0">
      <b-col md="2" class="beginner align-left p-0">
        <div class="d-none d-md-block">
          <side-menu-view
            :sidebar="menu"
            :category="category"
            :subCategory="subCategory"
            :term="term"
          ></side-menu-view>
        </div>
      </b-col>

      <b-col md="10" class="p-0">
        <div class="d-block d-sm-none">
            <ul class="category-list" id="scrollmenu">
              <li v-for="(item) in vendor.menuItems"
               :key="item.key" 
               @click="openCatalogPage(`${item.key}`)"
               :class="{'active' : $route.query.category == item.key}"
              >
                {{item.label}}
              </li>
            </ul>
        </div>
        <div v-if="data && data.length > 0" class="align-left row m-0">
          
          <div
            class="col-11 col-sm-6 col-lg-4 p-0"
            v-for="(product, pid) in data"
            v-bind:key="pid"
          >
            <div class="product-card align-left col-11 p-0 mx-2">
              <div class="link" @click="openProductDetail(product._id)">
                <div class="img-parent" v-if="product.thumbnailUrls.length > 0">
                  <search-result-view-image :product="product" />
                </div>
                <!-- <p
                v-else
                style="font-size: 5em; padding: 10px 0px; text-align: center; color: #bdbdbd"
              >
                <font-awesome-icon icon="shopping-bag" width="100%"/>
              </p> -->
                <div class="product-card-desc">
                  <p class="info">{{ product.store }}</p>
                  <p class="title">{{ product.name }}</p>

                  <p class="d-flex justify-content-between align-items-center">
                    <span>
                      <span
                        v-if="
                          product.marked_price &&
                          product.marked_price.amount > product.price.amount
                        "
                      >
                        <strong class="underline" style="color: red"
                          >{{ product.marked_price.currency }}
                          {{ product.marked_price.amount }}</strong
                        >&nbsp;&nbsp;
                      </span>

                      <strong>
                        <span class="price"
                          >{{ product.price.currency }}
                          {{ product.price.amount }}</span
                        >
                      </strong>
                    </span>
                 <!--   <button
                      id="add-to-cart-sync"
                      type="button"
                      class="btn add-to-cart btn-primary px-3 py-1 mb-1"
                      @click="addToCart(product, $event)"
                    >
                      Add
                    </button> -->
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div class="align-center">
            <b-btn
              class="primary-button"
              @click="loadMoreProducts()"
              v-show="data.length < paging.total"
              >See More</b-btn
            >
          </div>
        </div>
        <div v-else class="no-result">
          <div class="info" style="font-size: 50px">No result found ...</div>
        </div>
      </b-col>
    </b-row>
  </div>
</template>
<script>

import SearchResultViewImage from '@/components/vendor-pages/SearchResultViewImage.vue';
import SideMenuView from '@/components/vendor-pages/SideMenuView.vue';
import { mapGetters } from 'vuex';
import vendors from '@/vendors';

export default {
  name: 'SearchResultView',
  props: {
    data: {
      type: Array,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    menu: {
      required: true,
    },
    term: {
      required: false,
      default: '',
      type: String,
    },

    category: {
      required: false,
      default: '',
      type: String,
    },

    subCategory: {
      required: false,
      default: '',
      type: String,
    },

    paging: {
      required: false,
      default: null,
      type: Object,
    },
  },
  data() {
    return {
      product: null,
      selectedCustomizations: {},
      vendor: vendors[window.location.host],
    };
  },
  components: {
    SearchResultViewImage,
    SideMenuView,
  },
  created () {
    window.addEventListener('scroll', this.handleScroll);
  },
  destroyed () {
    window.removeEventListener('scroll', this.handleScroll);
  },
  methods: {
    handleScroll() {
      let scroll = document.getElementById("scrollmenu");
      if (window.pageYOffset > scroll.scrollHeight) {
        document.getElementById("scrollmenu").classList.add("sticky");
      } else {
        document.getElementById("scrollmenu").classList.remove("sticky");
      }
    },
    getPictureStyle(img) {
      return {
        'background-image': `url(${img})`,
        'background-size': 'cover',
        'margin-bottom': '10px',
      };
    },

    openProductDetail(pid) {
      this.$router.push(`/products/${pid}`);
    },

    loadMoreProducts() {
      this.$emit('nextpage');
    },
    openCatalogPage(cat) {
      this.$router.push({
        path: '/search',
        query: {
          category: cat,
        },
      });
      this.$emit('close');
    },

    async addToCart(product, event) {
      if (event) {
        event.stopPropagation();
      }
      if (!this.isSessionActive) {
        this.$router.push('/login')
        return;
      }
      this.product = product;
      this.product.customValues = {};
      // Selected Customization is just used for the simplicity. The values are also changed in this.product.
      this.selectedCustomizations = _.cloneDeep(this.product.customValues);

      Object.keys(this.selectedCustomizations).forEach((key) => {
        if (typeof this.selectedCustomizations[key] === 'string') {
          this.product.customValues[key] = this.selectedCustomizations[key];
        } else {
          this.product.customValues[key] = `${
            this.selectedCustomizations[key].name
          }|${this.selectedCustomizations[key].hexValue}`;
        }
      });
      const val = await this.$store.dispatch('cartStore/addToTheCart', [
        this.product,
      ]);
      if (val) {
        this.$notify({
          group: 'toast',
          type: 'success',
          text: `Added ${this.product.name} to the cart`,
          title: 'Added to Cart<font-awesome-icon icon="cart"/>',
        });
      } else {
        this.$notify({
          group: 'toast',
          type: 'warn',
          text: `${
            this.product.name
          } couldn't be added for some reason. Please try again later`,
        });
      }

    }
  },
  computed: {
    ...mapGetters({
      isSessionActive: 'authStore/isSessionActive'
    })
  },
};
</script>

<style lang="scss">
.search-result-view {
  text-align: left;
  width: 80%;
  margin: auto;
  padding: 30px 0px;
  padding-bottom: 3rem;
}

.result-view {
  margin-top: 1em;
}

.product-card {
  display: inline-block;
  // box-shadow: 3px 4px 5px 0px #ccc;
  background-color: white;
  border-radius: 0px;
  margin: 20px 20px 30px 0px;
  // width: 225px;
  box-shadow: 1px 1px 4px 1px #ccc;

  // &:hover .img-cls {
  //   transform: scale(1.2);
  //   transition: all 0.5s;
  // }

  .img-parent {
    height: 200px;
    // width: 225px;
    overflow: hidden;
  }

  .product-card-desc {
    margin-top: 0.5em;
    .title {
      height: 2em;
      text-overflow: ellipsis;
      overflow: hidden;
      color: black;
      font-weight: bold;
    }

    .price {
      font-weight: bold;
      color: black;
    }
  }

  .link {
    cursor: pointer;
  }
  p {
    padding: 3px 5px;
    margin: 0px;
  }
}
.bcrumb {
  font-size: 0.75em;
}
.product-detail {
  width: 90%;
  margin-left: auto;

  margin-bottom: 10px;
}

.no-result{
  margin-top: 50px;
  text-align: left;
}
#scrollmenu {
  width: 78vw;
  white-space: nowrap;
  overflow-x: auto;
  background: white;
  color: black;
  font-weight: 600;
  margin: 0 5px;
  z-index: 1;
  border-bottom: 1px solid #202428;
}

.sticky {
  position: fixed;
  top: 95px;
  z-index: 1;
}

#scrollmenu li {
  display: inline-block;
  float: none;
  padding: 10px 14px;
  cursor: pointer;
  margin: 0;
}
#scrollmenu .active {
  border-bottom: 3px solid red;
}

</style>
